/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import { helpers } from "vuelidate/lib/validators";

const passwordPattern = helpers.regex(
  "alpha",
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)[A-Za-z\d\W]{8,}$/
);
const sirenInvalid = helpers.regex("sirenInvalid", /^[0-9]{9}$/);
const siretInvalid = helpers.regex("siretInvalid", /^[0-9]{14}$/);
const INFO =
  "Ensemble des éléments constitutifs de votre dossier, notamment : preuve d’engagement, de réalisation et AH";
const DOCUMENT_TYPES = [
  {
    name: "Preuve d’engagement",
    code: "PREUVE_ENGAGEMENT",
    info: INFO
  },
  {
    name: "Preuve de réalisation",
    code: "PREUVE_REALISATION",
    info: INFO
  },
  {
    name: "Attestation sur l'honneur",
    code: "ATTESTATION_SUR_HONNEUR",
    info: INFO
  },
  {
    name: "Mandat",
    code: "MANDAT",
    info: INFO
  },
  {
    name: "Preuve du RAI",
    code: "PREUVE_RAI",
    info: INFO
  },
  {
    name: "Doc technique",
    code: "DOC_TECHNIQUE",
    info: INFO
  },
  {
    name: "Autre document",
    code: "AUTRE_DOCUMENT",
    info: INFO
  }
];

const DOCUMENT_TYPES_NEW = [
  {
    name: "Preuve d’engagement",
    code: "PREUVE_ENGAGEMENT",
    info: INFO
  },
  {
    name: "Preuve de réalisation",
    code: "PREUVE_REALISATION",
    info: INFO
  },
  {
    name: "Attestation sur l'honneur",
    code: "ATTESTATION_SUR_HONNEUR",
    info: INFO
  },
  {
    name: "Document technique",
    code: "DOC_TECHNIQUE",
    info: INFO
  },
  {
    name: "Certificat RGE",
    code: "CERTIFICAT_RGE",
    info: INFO
  },
  {
    name: "Audit énergétique",
    code: "AUDIT_ENERGETIQUE",
    info: INFO
  },
  {
    name: "Synthese de l'audit",
    code: "SYNTHESE_AUDIT",
    info: INFO
  },
  {
    name: "Mandat",
    code: "MANDAT",
    info: INFO
  },
  {
    name: "Mandat bénéficiaire",
    code: "MANDAT_BENEFICIAIRE",
    info: INFO
  },
  {
    name: "Avis d'imposition",
    code: "AVIS_IMPOSITION",
    info: INFO
  },
  {
    name: "Acte de sous traitance",
    code: "ACT_SOUS_TRAITANCE",
    info: INFO
  },
  {
    name: "Justificatif de domicile",
    code: "JUSTIFICATIF_DOMICILE",
    info: INFO
  },
  {
    name: "Pièce d'identité",
    code: "PIECE_IDENTITE",
    info: INFO
  },
  {
    name: "Note de dimensionnement",
    code: "NOTE_DIMENSIONNEMENT",
    info: INFO
  },
  {
    name: "Avenant",
    code: "AVENANT",
    info: INFO
  },
  {
    name: "Preuve RAI",
    code: "PREUVE_RAI",
    info: INFO
  },
  {
    name: "Autre",
    code: "AUTRE_DOCUMENT",
    info: INFO
  }
];

const DOCUMENT_TYPES_ARTISAN = [
  {
    name: "document_type.AUDIT_ENERGETIQUE",
    code: "AUDIT_ENERGETIQUE",
    info: INFO
  },
  {
    name: "document_type.PREUVE_ENGAGEMENT",
    code: "PREUVE_ENGAGEMENT",
    info: INFO
  },
  {
    name: "document_type.PREUVE_REALISATION",
    code: "PREUVE_REALISATION",
    info: INFO
  },
  {
    name: "document_type.ATTESTATION_SUR_HONNEUR",
    code: "ATTESTATION_SUR_HONNEUR",
    info: INFO
  },
  {
    name: "document_type.PREUVE_RAI",
    code: "PREUVE_RAI",
    info: INFO
  },
  {
    name: "document_type.DOC_TECHNIQUE",
    code: "DOC_TECHNIQUE",
    info: INFO
  },
  {
    name: "document_type.AUTRE_DOCUMENT",
    code: "AUTRE_DOCUMENT",
    info: INFO
  }
];

const APPLICATION_SECTORS = [
  {
    name: "Agriculture",
    value: "AGRICULTURE",
    types: [
      {
        name: "Equipement",
        value: "EQUIPEMENT"
      },
      {
        name: "Service",
        value: "SERVICE"
      },
      {
        name: "Thermique",
        value: "THERMIQUE"
      },
      {
        name: "Utilités",
        value: "UTILITES"
      }
    ]
  },
  {
    name: "Bâtiment résidentiel",
    value: "BAT_RES",
    types: [
      {
        name: "Enveloppe",
        value: "ENVELOPPE"
      },
      {
        name: "Equipement",
        value: "EQUIPEMENT"
      },
      {
        name: "Service",
        value: "SERVICE"
      },
      {
        name: "Thermique",
        value: "THERMIQUE"
      }
    ]
  },
  {
    name: "Bâtiment tertiaire",
    value: "BAT_TER",
    types: [
      {
        name: "Enveloppe",
        value: "ENVELOPPE"
      },
      {
        name: "Equipement",
        value: "EQUIPEMENT"
      },
      {
        name: "Service",
        value: "SERVICE"
      },
      {
        name: "Thermique",
        value: "THERMIQUE"
      }
    ]
  },
  {
    name: "Industrie",
    value: "INDUSTRIE",
    types: [
      {
        name: "Bâtiment",
        value: "BATIMENT"
      },
      {
        name: "Enveloppe",
        value: "ENVELOPPE"
      },
      {
        name: "Utilités",
        value: "UTILITES"
      }
    ]
  },
  // {
  // 	name: 'Programme',
  // 	value: 'PROGRAMME',
  // 	types: [

  // 	]
  // },
  {
    name: "Réseau",
    value: "RESEAU",
    types: [
      {
        name: "Chaleur",
        value: "CHALEUR"
      },
      {
        name: "Eclairage",
        value: "ECLAIRAGE"
      }
    ]
  },
  {
    name: "Transport",
    value: "TRANSPORT",
    types: [
      {
        name: "Equipement",
        value: "EQUIPEMENT"
      },
      {
        name: "Service",
        value: "SERVICE"
      }
    ]
  },
  {
    name: "Spécifique",
    value: "SPECIFIQUE",
    types: [
      {
        name: "Opération spécifique",
        value: "OPERATION_SPECIFIQUE"
      }
    ]
  }
];

const PRECARITY_CASES = [
  {
    name: "Pas de précarité",
    value: "NO"
  },
  {
    name:
      "Le bénéficiaire de l’opération est le ménage en situation de précarité (avec justificatifs)",
    value: "CASE_1"
  },
  {
    name: "Tous les logements sont conventionnées APL",
    value: "CASE_2"
  },
  {
    name: "Une partie des logements est conventionnée APL",
    value: "CASE_2_BIS"
  },
  {
    name:
      "L’opération concerne une copropriété objet d’une opération programmée d’amélioration de l’habitat ou plan de sauvegarde",
    value: "CASE_3"
  },
  {
    name: "Autre situation",
    value: "CASE_4"
  }
];

const DEPARTEMENTS = [
  { code: "01", name: "Ain", zone: "H1" },
  { code: "02", name: "Aisne", zone: "H1" },
  { code: "03", name: "Allier", zone: "H1" },
  { code: "04", name: "Alpes de Hautes-Provence", zone: "H2" },
  { code: "05", name: "Hautes-Alpes", zone: "H1" },
  { code: "06", name: "Alpes-Maritimes", zone: "H3" },
  { code: "07", name: "Ardèche", zone: "H2" },
  { code: "08", name: "Ardennes", zone: "H1" },
  { code: "09", name: "Ariège", zone: "H2" },
  { code: "10", name: "Aube", zone: "H1" },
  { code: "11", name: "Aude", zone: "H3" },
  { code: "12", name: "Aveyron", zone: "H2" },
  { code: "13", name: "Bouches-du-Rhône", zone: "H3" },
  { code: "14", name: "Calvados", zone: "H1" },
  { code: "15", name: "Cantal", zone: "H1" },
  { code: "16", name: "Charente", zone: "H2" },
  { code: "17", name: "Charente-Maritime", zone: "H2" },
  { code: "18", name: "Cher", zone: "H2" },
  { code: "19", name: "Corrèze", zone: "H1" },
  { code: "2A", name: "Corse-du-Sud", zone: "H3" },
  { code: "2B", name: "Haute-Corse", zone: "H3" },
  { code: "21", name: "Côte-d'Or", zone: "H1" },
  { code: "22", name: "Côtes d'Armor", zone: "H2" },
  { code: "23", name: "Creuse	Guéret", zone: "H1" },
  { code: "24", name: "Dordogne", zone: "H2" },
  { code: "25", name: "Doubs", zone: "H1" },
  { code: "26", name: "Drôme", zone: "H2" },
  { code: "27", name: "Eure", zone: "H1" },
  { code: "28", name: "Eure-et-Loir", zone: "H1" },
  { code: "29", name: "Finistère", zone: "H2" },
  { code: "30", name: "Gard", zone: "H3" },
  { code: "31", name: "Haute-Garonne", zone: "H2" },
  { code: "32", name: "Gers", zone: "H2" },
  { code: "33", name: "Gironde", zone: "H2" },
  { code: "34", name: "Hérault", zone: "H3" },
  { code: "35", name: "Ille-et-Vilaine", zone: "H2" },
  { code: "36", name: "Indre", zone: "H2" },
  { code: "37", name: "Indre-et-Loire", zone: "H2" },
  { code: "38", name: "Isère", zone: "H1" },
  { code: "39", name: "Jura", zone: "H1" },
  { code: "40", name: "Landes", zone: "H2" },
  { code: "41", name: "Loir-et-Cher", zone: "H2" },
  { code: "42", name: "Loire", zone: "H1" },
  { code: "43", name: "Haute-Loire", zone: "H1" },
  { code: "44", name: "Loire-Atlantique", zone: "H2" },
  { code: "45", name: "Loiret", zone: "H1" },
  { code: "46", name: "Lot", zone: "H2" },
  { code: "47", name: "Lot-et-Garonne", zone: "H2" },
  { code: "48", name: "Lozère", zone: "H2" },
  { code: "49", name: "Maine-et-Loire", zone: "H2" },
  { code: "50", name: "Manche", zone: "H2" },
  { code: "51", name: "Marne", zone: "H1" },
  { code: "52", name: "Haute-Marne", zone: "H1" },
  { code: "53", name: "Mayenne", zone: "H2" },
  { code: "54", name: "Meurthe-et-Moselle", zone: "H1" },
  { code: "55", name: "Meuse", zone: "H1" },
  { code: "56", name: "Morbihan", zone: "H2" },
  { code: "57", name: "Moselle", zone: "H1" },
  { code: "58", name: "Nièvre", zone: "H1" },
  { code: "59", name: "Nord", zone: "H1" },
  { code: "60", name: "Oise", zone: "H1" },
  { code: "61", name: "Orne", zone: "H1" },
  { code: "62", name: "Pas-de-Calais", zone: "H1" },
  { code: "63", name: "Puy-de-Dôme", zone: "H1" },
  { code: "64", name: "Pyrénées-Atlantiques", zone: "H2" },
  { code: "65", name: "Hautes-Pyrénées", zone: "H2" },
  { code: "66", name: "Pyrénées-Orientales", zone: "H3" },
  { code: "67", name: "Bas-Rhin", zone: "H1" },
  { code: "68", name: "Haut-Rhin", zone: "H1" },
  { code: "69", name: "Rhône", zone: "H1" },
  { code: "70", name: "Haute-Saône", zone: "H1" },
  { code: "71", name: "Saône-et-Loire", zone: "H1" },
  { code: "72", name: "Sarthe", zone: "H2" },
  { code: "73", name: "Savoie", zone: "H1" },
  { code: "74", name: "Haute-Savoie", zone: "H1" },
  { code: "75", name: "Paris", zone: "H1" },
  { code: "76", name: "Seine-Maritime", zone: "H1" },
  { code: "77", name: "Seine-et-Marne", zone: "H1" },
  { code: "78", name: "Yvelines", zone: "H1" },
  { code: "79", name: "Deux-Sèvres", zone: "H2" },
  { code: "80", name: "Somme", zone: "H1" },
  { code: "81", name: "Tarn", zone: "H2" },
  { code: "82", name: "Tarn-et-Garonne", zone: "H2" },
  { code: "83", name: "Var", zone: "H3" },
  { code: "84", name: "Vaucluse", zone: "H2" },
  { code: "85", name: "Vendée", zone: "H2" },
  { code: "86", name: "Vienne", zone: "H2" },
  { code: "87", name: "Haute-Vienne", zone: "H1" },
  { code: "88", name: "Vosges", zone: "H1" },
  { code: "89", name: "Yonne", zone: "H1" },
  { code: "90", name: "Territoire-de-Belfort", zone: "H1" },
  { code: "91", name: "Essonne", zone: "H1" },
  { code: "92", name: "Hauts-de-Seine", zone: "H1" },
  { code: "93", name: "Seine-Saint-Denis", zone: "H1" },
  { code: "94", name: "Val-de-Marne", zone: "H1" },
  { code: "95", name: "Val-d'Oise", zone: "H1" }
];

const VIEW_PROJECT = "VIEW_PROJECT";
const VIEW_SIMULATION = "VIEW_SIMULATION";
const CREATE_SIMULATION = "CREATE_SIMULATION";
const VALIDATE_SIMULATION = "VALIDATE_SIMULATION";
const VIEW_CONTRACT = "VIEW_CONTRACT";
const MANAGE_USERS = "MANAGE_USERS";
const MANAGE_AGENCES = "MANAGE_AGENCES";

const ROLE_PERMISSIONS = [
  VIEW_PROJECT,
  VIEW_SIMULATION,
  CREATE_SIMULATION,
  VALIDATE_SIMULATION,
  VIEW_CONTRACT,
  MANAGE_USERS,
  MANAGE_AGENCES
];

const ERROR_CODE = {
  GWBE00012: "GWBE00012",
  GWBE00013: "GWBE00013",
  GWBE00016: "GWBE00016"
};

const ROLE_TYPE = {
  ADMIN: "ADMIN",
  ADMIN_AGENCE: "ADMIN_AGENCE",
  USER: "USER",
  VIEWER: "VIEWER"
};

const SIMULATION_TYPE = {
  SIMPLE: "SIMPLE",
  COMPLEX: "COMPLEX",
  IMPORT_MASS: "IMPORT_MASS"
};

const USER_TYPE = {
  BAILLEUR_SOCIAL: "BAILLEUR_SOCIAL",
  B2B: "B2B",
  B2B2B: "B2B2B",
  ARTISAN: "ARTISAN"
};

const IMPORT_TYPE = {
  OPERATION_IMPORT: "OPERATION_IMPORT",
  KLAXIT_ANNEXE_3: "KLAXIT_ANNEXE_3",
  CONTACT_CONTROL: "CONTACT_CONTROL",
  ESTIMATION_IMPORT: "ESTIMATION_IMPORT",
  EDIT_ESTIMATION_IMPORT: "EDIT_ESTIMATION_IMPORT"
};

const BENEFICIARY_TYPES = {
  SOCIAL_LESSOR: "Bailleur social",
  CO_OWNER_SYNDICATE: "Syndicat de copropriétaires",
  OTHER: "AUTRE"
};
const EntityType = {
  PROJECT: "PROJECT",
  SIMULATION: "SIMULATION",
  ALL: "ALL"
};
const ALLOWED_OPERATIONS_STATUS = [
  "OPERATION_CREATED",
  "WORK_ENGAGED",
  "COMPLETED_WORK",
  "JUSTIFICATIVE_RECEIVED"
];
const emailForbiddenPattern = helpers.regex(
  "emailForbiddenPattern",
  /^[^@]+@(?!.*leyton)[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/i
);
const phonePattern = helpers.regex("phone", /^\+?(?:[0-9] ?){6,14}[0-9]$/);
const MAX_AVATAR_SIZE = 2 * 1024 * 1024; // max avatar size 2MB
const MIN_PASSWORD_LENGTH = 8;
const MAX_PASSWORD_LENGTH = 254;
const BLOCKED_EXTENSIONS = [
  "php",
  "php5",
  "html",
  "jsx",
  "js",
  "cmd",
  "sh",
  "sql"
];

export const constants = {
  passwordPattern,
  DOCUMENT_TYPES,
  DOCUMENT_TYPES_NEW,
  DOCUMENT_TYPES_ARTISAN,
  APPLICATION_SECTORS,
  PRECARITY_CASES,
  DEPARTEMENTS,
  ROLE_PERMISSIONS,
  VIEW_PROJECT,
  VIEW_SIMULATION,
  CREATE_SIMULATION,
  VALIDATE_SIMULATION,
  VIEW_CONTRACT,
  MANAGE_USERS,
  MANAGE_AGENCES,
  phonePattern,
  MAX_AVATAR_SIZE,
  MIN_PASSWORD_LENGTH,
  MAX_PASSWORD_LENGTH,
  ERROR_CODE,
  ROLE_TYPE,
  USER_TYPE,
  sirenInvalid,
  siretInvalid,
  BENEFICIARY_TYPES,
  SIMULATION_TYPE,
  IMPORT_TYPE,
  ALLOWED_OPERATIONS_STATUS,
  EntityType,
  emailForbiddenPattern,
  BLOCKED_EXTENSIONS
};
